import countriesEU from './customer-countries-EU.json'

export const countries = countriesEU

export function getCountryGermanNameByName(name) {
  return (
    countries.find(country => country.name === name)?.germanName ?? 'unbekannt'
  )
}
